import Vue from 'vue';
import './plugins/base';
import vuetify from './plugins/vuetify';
import App from './App.vue';
import router from './router';
import store from './store/';
import './registerServiceWorker';
import i18n from './language';
import '@/shared/filters';

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    vuetify,
    i18n,
    beforeCreate() {
        console.log('Before our APP is created');
    },
    async created() {
        console.log('Our APP is being created now.');
        await this.$store.dispatch('initStore');
        this.$i18n.locale = this.$store.state.language;
        this.$vuetify.lang.current = this.$store.state.language;
    },
    mounted() {
        console.log('Our APP is being mounted now.');
    },
    render: function(h) {
        return h(App);
    }
}).$mount('#app');
